var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('key-preferences',{attrs:{"keys":_vm.consecutive,"keyTransform":_vm.transform,"instruction":"Please indicate your preferences to teach classes spread out over one or multiple days","allowUnavailable":false},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }